import { Stack, useLocalSearchParams } from 'expo-router';
import React from 'react';

import { ExperimentPage } from '../../../../../llm-service/datasets/ExperimentsPage';

const readParam = (value: string | string[] | undefined): string => {
    if (typeof value === 'string') {
        return value;
    }
    return value?.[0] ?? '';
};

export default function ExperimentRoute() {
    const { agentId, experimentId } = useLocalSearchParams<{
        agentId: string;
        experimentId: string;
    }>();

    return (
        <>
            <Stack.Screen
                options={{
                    title: 'Experiment',
                }}
            />
            <ExperimentPage
                agentId={readParam(agentId)}
                experimentId={readParam(experimentId)}
            />
        </>
    );
}
